export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-array/src/constant.js
// module id = 269
// module chunks = 0